import { Component, Input } from '@angular/core';
import { StatusStateType } from '@shared/service-proxies/crm-Service-proxies';

@Component({
  selector: 'app-timeline-box',
  templateUrl: './timeline-box.component.html',
  styleUrls: ['./timeline-box.component.css']
})
export class TimelineBoxComponent {

  @Input() time: string = "";
  @Input() icon: string = "";
  @Input() name: string = "";
  @Input() actionName: string = "";
  @Input() appDesc: string = "";
  @Input() statusType: StatusStateType = StatusStateType.SUCCESS;


  getColorClass() {
    switch (this.statusType){
      case StatusStateType.DANGER:
        return "danger-card";
      case StatusStateType.PENDING:
        return "pending-card";
      case StatusStateType.DEFAULT:
        return "default-card";
      case StatusStateType.SUCCESS:
        return "success-card";
      case StatusStateType.WARNING:
        return "warning-card";
    }
  }

  GettimeLineClass() {
    switch (this.statusType){
      case StatusStateType.DANGER:
        return "danger-timeline";
      case StatusStateType.PENDING:
        return "pending-timeline";
      case StatusStateType.DEFAULT:
        return "default-timeline";
      case StatusStateType.SUCCESS:
        return "success-timeline";
      case StatusStateType.WARNING:
        return "warning-timeline";
    }
  }
}
